(() => {
  if (window.twCartDiscountInitialized) return;
  window.twCartDiscountInitialized = true;

  document.addEventListener('click', (event) => {
    const checkoutButton = event.target.closest('#checkout, [data-tw-cart-checkout], #CartDrawer-Checkout, #cart-notification-form [name="checkout"]');
    if (!checkoutButton || checkoutButton.disabled) return;

    const formId = checkoutButton.getAttribute('form') || checkoutButton.closest('form')?.id;
    const discountInput = document.querySelector(`[data-cart-discount-code][form="${formId}"]`);
    const discountCode = discountInput?.value.trim();

    if (!discountCode) return;

    event.preventDefault();
    checkoutButton.disabled = true;
    checkoutButton.setAttribute('aria-busy', 'true');

    const redirect = encodeURIComponent('/checkout');
    window.location.assign(`${window.shopUrl}/discount/${encodeURIComponent(discountCode)}?redirect=${redirect}`);
  });
})();
